import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import {getScreen} from "../../store/reducers/screen";
import {IState} from "../../store/store";

//  define props for the settable component

export interface IScreenInputProps
{
    screen: string;
}

interface IInternalProps
{
    active_screen: string;
}

export interface IScreenComponentProps
{
    active: boolean;
}


/**
 * react higher-order-component creator factory function;
 * this function returns a function we can call to wrap components, making them settable
 */
export const screenComponent = () =>
{
    return (Component: any) : React.ComponentClass<IScreenInputProps> =>
    {
        class ScreenComponent extends React.Component<IScreenInputProps & IInternalProps, null>
        {
            constructor(public props: IScreenInputProps & IInternalProps)
            {
                super(props);
            }


            /**
             * render the component
             * @returns {JSX.Element}
             */
            render() : JSX.Element
            {
                return <Component active={this.props.screen === this.props.active_screen} {...this.props}/>
            }
        }

        function mapStateToProps(state: IState)
        {
            return {
                active_screen: getScreen(state)
            };
        }

        function mapDispatchToProps(dispatch)
        {
            return {
                // setInputSetting: (breakpoint_index: number, setting_id: string, settings: ISetting) => dispatch(setInputSetting(breakpoint_index, setting_id, settings))
            };
        }

        return connect(mapStateToProps, mapDispatchToProps)(ScreenComponent);
    };
};



// /**
//  * react higher-order-component creator factory function;
//  * this function returns a function we can call to wrap components, making them settable
//  */
// export const screenComponent = () =>
// {
//     return <IOriginalProps extends any>(Component: React.ComponentClass<IScreenComponentProps>) : React.ComponentClass<IScreenInputProps> =>
//     {
//         class ScreenComponent extends React.Component<IScreenInputProps & IInternalProps, null>
//         {
//             constructor(public props: IScreenInputProps & IInternalProps)
//             {
//                 super(props);
//             }
//
//
//             /**
//              * render the component
//              * @returns {JSX.Element}
//              */
//             render() : JSX.Element
//             {
//                 return <Component active={this.props.screen === this.props.active_screen} {...this.props}/>
//             }
//         }
//
//         function mapStateToProps(state: IState)
//         {
//             return {
//                 active_screen: getScreen(state)
//             };
//         }
//
//         function mapDispatchToProps(dispatch)
//         {
//             return {
//                 // setInputSetting: (breakpoint_index: number, setting_id: string, settings: ISetting) => dispatch(setInputSetting(breakpoint_index, setting_id, settings))
//             };
//         }
//
//         return connect(mapStateToProps, mapDispatchToProps)(ScreenComponent);
//     };
// };



// WEBPACK FOOTER //
// ./src/ts/app/screens/screenComponent.tsx